import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../slices/cartSlice";
import ProductCard from "./ProductCard";
import { useGetLatestProductsQuery } from "../../slices/productSlice";
import Loader from "../utilComponents/Loader";
import marketplace from "../../assets/images/marketplace.svg";

const SponsoredProductsList = () => {
  const { data: products, isLoading, isError } = useGetLatestProductsQuery();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (isLoading)
    return (
      <div>
        <Loader count={6} columns={6} itemClass="h-[280px] w-[200px]" />
      </div>
    );

  if (isError)
    return <div className="text-red-error">Failed to load products</div>;

  // Just show the first 5 products, no filtering
  const firstFiveProducts = (products || []).slice(0, 5);

  return (
    <div className="lg:container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {firstFiveProducts.map((product) => (
        <ProductCard
          key={product._id}
          image={product.images[0]}
          title={product.title}
          originalPrice={product.originalPrice}
          discountedPrice={product.discountedPrice}
          sponsored={product.isSponsored}
          topSelling={product.isTopSelling}
          vendor={product.vendor?.storeName || "Unknown Vendor"}
          vendorId={product.vendor?._id || ""}
          productId={product._id}
          rating={product.averageRating}
          reviews={product.numReviews}
          onAddToCart={(item) => dispatch(addToCart(item))}
          onClickProductCard={() => navigate(`/products/${product._id}`)}
        />
      ))}

      {/* CTA Card */}
      <div
        onClick={() => navigate("/shop")}
        className="h-[324px] w-[200px] bg-agBg cursor-pointer flex items-center justify-center rounded-lg text-agBlack font-semibold text-sm hover:opacity-90 transition hover:bg-agPrimaryLight flex flex-col space-y-4"
      >
        <img src={marketplace} alt="market place" className=" w-[72px]" />
        <p className="text-center text-lg text-agBlack font-nunito font-semibold">
          Go to <br />
          Marketplace
        </p>
      </div>
    </div>
  );
};

export default SponsoredProductsList;
